import { Link } from "react-router-dom";

export function LegalPage({
  kind,
}: {
  kind: "privacy" | "terms" | "not-found";
}) {
  if (kind === "not-found")
    return (
      <article className="legal-page">
        <p className="eyebrow">404</p>
        <h1>This page slipped between the folds.</h1>
        <p>The address may be incomplete or the page may have moved.</p>
        <Link className="button button--secondary" to="/">
          Return home
        </Link>
      </article>
    );
  return (
    <article className="legal-page">
      <p className="eyebrow">
        {kind === "privacy" ? "Privacy, in plain language" : "Pilot terms"}
      </p>
      <h1>
        {kind === "privacy"
          ? "The letter belongs to the people reading it."
          : "A careful pilot, not permanent post."}
      </h1>
      {kind === "privacy" ? (
        <>
          <h2>What stays on your device</h2>
          <p>
            Raw camera captures, draft edits, crop points, and creator
            credentials are stored in your browser. They are not synchronized.
          </p>
          <h2>What leaves your device</h2>
          <p>
            Only the final encrypted letter package, its random identifier,
            size, lifecycle status, and privacy-safe aggregate events. Names and
            handwriting remain inside the encrypted package.
          </p>
          <h2>What a private link means</h2>
          <p>
            The decryption key lives after the # in the complete link and is not
            sent to Fold’s servers. Anyone who has the complete link may open or
            forward the letter.
          </p>
          <h2>Revocation and expiry</h2>
          <p>
            Revocation prevents new access but cannot recall screenshots or
            saved copies. Anonymous letters expire after the period chosen by
            the sender.
          </p>
        </>
      ) : (
        <>
          <h2>Use with care</h2>
          <p>
            Fold is a closed-pilot service. Do not use it for illegal material,
            harassment, threats, or information that requires regulated archival
            guarantees.
          </p>
          <h2>No permanence promise</h2>
          <p>
            Drafts can disappear when browser data is cleared. Cloud letters
            expire. Keep a personal PDF of anything you need to preserve.
          </p>
          <h2>Service limits</h2>
          <p>
            Pilot letters are limited to ten pages and an eight MiB encrypted
            package. The service may restrict abusive or automated creation.
          </p>
        </>
      )}
      <p className="legal-page__back">
        <Link to="/">← Back to Fold</Link>
      </p>
    </article>
  );
}
